import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserModule } from '@angular/platform-browser';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpClientJsonpModule,
} from '@angular/common/http';
import {
  MsalModule,
  MsalRedirectComponent,
  MsalGuard,
  MsalInterceptor
} from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';

import { HomeComponent } from './pages/Home/home.component';
import { HeaderComponent } from './pages/Home/header/header.component';
import { InfoBarComponent } from './pages/Home/info-bar/info-bar.component';
import { FooterComponent } from './pages/Home/footer/footer.component';
import { LocationsComponent } from './pages/Home/locations/locations.component';
import { DockComponent } from './components/dock/dock.component';
import { CabinasComponent } from './pages/Cabinas/cabinas.component';
import { ChassisComponent } from './pages/Chassis/chassis.component';
import { KDComponent } from './pages/KD/kd.component';
import { HeaderLCBRecebComponent } from './components/header-lcb/header-lcbreceb.component';
import { LCBRecebimentoComponent } from './pages/LCB_Recebimento/lcb-recebimento.component';
import { LCBExpedicaoComponent } from './pages/LCB_Expedicao/lcb-expedicao.component';
import { FilasComponent } from './pages/Filas/filas.component';
import { TaktComponent } from './components/takt/takt.component';
import { TimeTableComponent } from './components/time-table/time-table.component';
import { TimeTableFormComponent } from './components/time-table-form/time-table-form.component';
import { TripDetailsComponent } from './pages/Chassis/trip-details/trip-details.component';
import { TripDetailsKdComponent } from './pages/KD/trip-details-kd/trip-details-kd.component';
import { ViewExpComponent } from './pages/LCB_Expedicao/view-exp/view-exp.component';
import { ViewChassisComponent } from './pages/Chassis/view-chassis/view-chassis.component';
import { ViewKDComponent } from './pages/KD/view-kd/view-kd.component';
import { environment } from 'src/environments/environment';
import { TripDetailsEmbalagensComponent } from './pages/LCB_Embalagens/trip-details-embalagens/trip-details-embalagens.component';
import { LCBEmbalagensComponent } from './pages/LCB_Embalagens/lcb-embalagens.component';
import { PlanningTableComponent } from './components/planning-table/planning-table.component';
import { FiscoTableComponent } from './components/fisco-table/fisco-table.component';
import { MilkrunTableComponent } from './components/milkrun-table/milkrun-table.component';
import { PackingIntegrationFormComponent } from './components/packing-integration-form/packing-integration-form.component';
import { ViewEmbComponent } from './pages/LCB_Embalagens/view-emb/view-emb.component';
import { TripDetailsRecComponent } from './pages/LCB_Recebimento/trip-details-rec/trip-details-rec.component';
import { ViewRecComponent } from './pages/LCB_Recebimento/view-rec/view-rec.component';
import { PlanningTableFormComponent } from './components/planning-table-form/planning-table-form.component';
import { ChassisTimeTableComponent } from './components/chassis-time-table/chassis-time-table.component';
import { ChassisTimeTableFormComponent } from './components/chassis-time-table-form/chassis-time-table-form.component';
import { ChassisIntegrationFormComponent } from './components/chassis-integration-form/chassis-integration-form.component';
import { MotoresTransmissaoComponent } from './pages/Motores_Transmissao/motores-transmissao.component';
import { TripDetailsMotoresTransmissaoComponent } from './pages/Motores_Transmissao/trip-detais-motores-transmissao/trip-detais-motores-transmissao.component';
import { MotoresTransmissaoTimeTableComponent } from './components/motores-transmissao-time-table/motores-transmissao-time-table.component';
import { MotoresTransmissaoTimeTableFormComponent } from './components/motores-transmsissao-time-table-form/motores-transmsissao-time-table-form.component';
import { ViewMotoresTransmissaoComponent } from './pages/Motores_Transmissao/view-motores-transmissao/view-motores-transmissao.component';
import { MotoresTransmissaoIntegrationFormComponent } from './components/motores-transmissao-integration-form/motores-transmissao-integration-form.component';
registerLocaleData(en);

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    HeaderLCBRecebComponent,
    InfoBarComponent,
    FooterComponent,
    LocationsComponent,
    DockComponent,
    CabinasComponent,
    ChassisComponent,
    ChassisTimeTableComponent,
    ChassisTimeTableFormComponent,
    ChassisIntegrationFormComponent,
    MotoresTransmissaoComponent,
    MotoresTransmissaoTimeTableComponent,
    MotoresTransmissaoTimeTableFormComponent,
    MotoresTransmissaoIntegrationFormComponent,
    KDComponent,
    LCBRecebimentoComponent,
    LCBExpedicaoComponent,
    LCBEmbalagensComponent,
    TaktComponent,
    TimeTableComponent,
    TimeTableFormComponent,
    PlanningTableComponent,
    PlanningTableFormComponent,
    FiscoTableComponent,
    MilkrunTableComponent,
    PackingIntegrationFormComponent,
    FilasComponent,
    TripDetailsComponent,
    TripDetailsKdComponent,
    TripDetailsEmbalagensComponent,
    TripDetailsRecComponent,
    TripDetailsMotoresTransmissaoComponent,
    ViewExpComponent,
    ViewKDComponent,
    ViewChassisComponent,
    ViewEmbComponent,
    ViewRecComponent,
    ViewMotoresTransmissaoComponent
  ],
  imports: [
    FontAwesomeModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ReactiveFormsModule,
    FormsModule,
    FlexLayoutModule,
    BrowserAnimationsModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: 'acd69533-1b29-465c-acaf-2edb9e630f3f',
          authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac',
          redirectUri: environment.redirectUri,
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: ['user.read'],
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          [
            environment.apiLink + '/Trucks',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Docks',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/KD',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Emb',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Line',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Locations',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Sensor',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/SensorExp',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/TaktConfig',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/TimeTable',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Configurations',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Chassis',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/EngineAndTransmission',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/MotoresTransmissao',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Queues',
            [environment.protectedResource]
          ],
          [
            environment.apiLink + '/Trips',
            [environment.protectedResource]
          ]
        ]),
      }
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },

    MsalGuard,
  ],
  bootstrap: [
    AppComponent,
    MsalRedirectComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }
